import React, { ReactNode } from 'react';
import { ItemDataType } from 'rsuite5/esm/@types/common';
import { CheckPicker, CheckPickerProps as RSCheckPickerProps } from 'rsuite5';
import { FieldProps } from 'formik';
import _ from 'lodash';

export interface CheckPickerProps extends Omit<RSCheckPickerProps<any>, 'form'>, FieldProps {}

const BicesterCheckPicker = ({
  field,
  form,
  data,
  className,
  style,
  placeholder = ' ',
  defaultValue,
  disabledItemValues,
  cleanable,
  onClean,
  ...props
}: {
  data: ItemDataType[];
  className?: string;
  style?: any;
  placeholder?: ReactNode;
  defaultValue?: any;
  disabledItemValues?: any[];
  cleanable?: boolean;
  onClean?: (event: React.SyntheticEvent<Element, Event>) => void;
  [rest: string]: any;
} & CheckPickerProps) => {
  return (
    <CheckPicker
      name={field.name}
      value={field.value}
      className={className}
      data={data}
      style={style}
      placeholder={placeholder}
      defaultValue={defaultValue}
      disabledItemValues={disabledItemValues}
      searchable={false}
      cleanable={cleanable}
      onClean={(event) => {
        onClean && onClean(event);
        form.setFieldValue(field.name, '');
      }}
      onChange={(value, event) => {
        form.setFieldValue(field.name, value);
        field.onChange(event);
      }}
      {...props}
    />
  );
};

export default BicesterCheckPicker;
